import { PnetService, PnetServiceRequestType } from '@previnet/service';
import config from "@/services/config";

const baseUrl = `${window.location.protocol}//${window.location.hostname}:${window.location.port}/` + config.serviceContext;
const loginUrl = baseUrl + `/api/public/login`;
const logoutUrl = baseUrl + `/api/public/logout`;
const recuperoPasswordUrl = baseUrl + `/api/public/password-recovery`;
const validateRecuperoPasswordUrl = baseUrl + `/api/public/ssoMailRecuperoPassword/validate`;
const loginRecuperoPasswordUrl = baseUrl + `/api/public/ssoMailRecuperoPassword/login`;


const headers = new Headers();

export default class LoginService extends PnetService {

  public doLogin(params: any): Promise<Response> {
    const serviceCallReturnValue = this.fetch(
      loginUrl,
      {
        method: 'POST',
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        },
        type: PnetServiceRequestType.urlenconded,
        body: params
      },
      {
      }
    );

    return serviceCallReturnValue;
  }

  public doLogout(): Promise<Response> {
    const serviceCallReturnValue = this.fetch(
      logoutUrl,
      {
        method: 'GET',
        headers,
      },
      {
      }
    );

    return serviceCallReturnValue;
  }

  public recuperoPassword(params: any): Promise<Response> {
    const serviceCallReturnValue = this.fetch(
      recuperoPasswordUrl,
      {
        method: 'POST',
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        },
        type: PnetServiceRequestType.urlenconded,
        body: params
      },
      {
      }
    );

    return serviceCallReturnValue;
  }

  public validateRecuperoPassword(token: any): Promise<Response> {
    const serviceCallReturnValue = this.fetch(
      validateRecuperoPasswordUrl + "?token=" + token,
      {
        method: 'POST',
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        },
        type: PnetServiceRequestType.urlenconded,
        body: {
          token: token
        }
      },
      {
      }
    );

    return serviceCallReturnValue;
  }

  public loginRecuperoPassword(params: any): Promise<Response> {
    const serviceCallReturnValue = this.fetch(
      loginRecuperoPasswordUrl,
      {
        method: 'POST',
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        },
        type: PnetServiceRequestType.urlenconded,
        body: params
      },
      {
      }
    );

    return serviceCallReturnValue;
  }

}
